module.exports = __webpack_public_path__ + "static/media/Arrow-Right.1766481d.svg";